<template>
  <modal
    name="member-list-modal"
    class="popup-banner-modal"
    :width="'500px'"
    :height="'auto'"
    @before-close="handlerBeforeClose"
    @before-open="handlerBeforeOpen"
    @opened="handlerOpened"
  >
    <div class="list-container pa15">
      <div class="title">회원리스트</div>
      <div ><button class="close_btn" type="cancel" @click="close"></button></div>
      <member-list-component :memberType="'memberModal'" :ssamsType="ssamsType"></member-list-component>
    </div>
  </modal>
</template>

<script>
import util from "@/mixins/util";

import MemberListComponent from "@/components/member/MemberListComponent";
import EventBus from "@/utils/event-bus";

export default {
  name: "MemberListModal",
  mixins: [],
  components: {
    MemberListComponent,
  },
  provide() {
    return {
      runSelectMember: this.selectData,
            checkSelect: this.checkSelect,
    };
  },
  props: {
    ssamsType: ''
  },
  data() {
    return {
      memberList: []
    }
  },
  beforeRouterEnter() {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  computed: {},
  methods: {
    handlerBeforeOpen(event) {
            if (!util.isEmpty(event.params) && !util.isEmpty(event.params.memberList)) {
                this.memberList = event.params.memberList
            }
        },
    handlerOpened() {},
    handlerBeforeClose() {
      if (this.$route.path != this.$route.fullPath) {
        this.$router.replace(this.$route.path);
      }
    },
    close() {
      this.$modal.hide("member-list-modal");
    },

    selectData(member) {
        EventBus.$emit('runSelectMember', member);
        this.backEvent();
    },
    checkSelect(key) {
        let memberIndex = this.memberList.findIndex(member => member.mb_no === key);
        if (memberIndex > -1) {
            return false
        }
        return true
    },
    backEvent() {
            this.$modal.hide('member-list-modal');
        },
  },
  watch: {},
};
</script>

<style scoped></style>
